import { makeStyles } from '@material-ui/styles'

const styles = makeStyles(() => ({
  configButton: { boxShadow: '1px 1px 1px 1px #dedede', width: '50%', padding: 20 },
  configButtonIcon: { fontSize: 28 },
}))

export default styles
